var render = function render(_c,_vm){return _c('div',[_vm._v(_vm._s(_vm.$options.formatterMoney(_vm.props.row[_vm.props.column])))])
}
var staticRenderFns = []

export { render, staticRenderFns }